import { render, staticRenderFns } from "./TenantSelect.vue?vue&type=template&id=8c2f52ee&scoped=true"
import script from "./TenantSelect.vue?vue&type=script&lang=js"
export * from "./TenantSelect.vue?vue&type=script&lang=js"
import style0 from "./TenantSelect.vue?vue&type=style&index=0&id=8c2f52ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2f52ee",
  null
  
)

export default component.exports